export interface ArsPageByItem<T> {
  groupingFactorId: string;
  label?: T;
}
